import API from "../../common/utils/API";
import {activityLoggerActionTypes} from "../veritas-middleware/constants/UtilityMiddlewareConstants";

/**
 * This is the activity logger middleware. A POST or PUT API call is followed by an
 * action dispatch to this middleware which takes the object_id, object_type and user
 * and logs it as a change.
 * @param store
 * @returns {function(*): function(...[*]=)}
 */
const activityLoggerMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case activityLoggerActionTypes.LOG_CHANGE: {
            next(action);
            const { log, authToken } = action.payload;

            return API.postChange(log, authToken.idToken)
                .then(res => {
                    console.log(res);
                })
                .catch(err => console.log(err));
        }

        case activityLoggerActionTypes.LOG_STATUS_CHANGE: {
            next(action);
            const { log, authToken } = action.payload;

            return API.logStatusChange(log, authToken.idToken)
                .then(res => {
                    console.log(res);
                })
                .catch(err => console.log(err));
        }

        default: next(action);
    }
}

export default activityLoggerMiddleware;
